import React, { useState, useEffect } from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styles from './style.module.scss'
import cn from 'classnames'
import LightYoutube from '../light-youtube'

export default () => {
    const { allWordpressWpPropertyTalk } = useStaticQuery(graphql`
        {
            allWordpressWpPropertyTalk {
                nodes {
                    wordpress_id
                    title
                    acf {
                        youtube_iframe
                    }
                }
            }
        }
    `)

    const [searchTerm, setSearchTerm] = useState('')

    const [propertyTalks, setPropertyTalks] = useState(
        allWordpressWpPropertyTalk.nodes
    )

    const [placeholderText, setPlaceholderText] = useState('Search')

    useEffect(() => {
        if (
            !allWordpressWpPropertyTalk ||
            !allWordpressWpPropertyTalk.nodes.length
        )
            return

        setPropertyTalks(
            allWordpressWpPropertyTalk.nodes.filter(t => {
                try {
                    return t.title.toLowerCase().match(searchTerm.toLowerCase())
                } catch (ex) {
                    return false
                }
            })
        )
    }, [searchTerm, allWordpressWpPropertyTalk])

    useEffect(() => {
        const topics = [
            'Chinese',
            'Whats coming',
            'Dubai',
            'Professional agent',
            'Landlord',
            'Tenant',
            'Expo 2020',
            'Development'
        ]
        const randomTitle = topics[Math.floor(Math.random() * topics.length)]
        setPlaceholderText('Try ' + randomTitle)
    }, [])

    return (
        <div className="wrapper">
            <div className="row">
                <div className="col-xs-12">
                    <h1 className={styles.pageTitle}>Search for a topic</h1>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <input
                        className={styles.searchBox}
                        type="search"
                        value={searchTerm}
                        placeholder={placeholderText}
                        onChange={e => setSearchTerm(e.target.value)}
                    />
                </div>
                {propertyTalks.map(talk => (
                    <div
                        className={cn('col-xs-12 col-md-6')}
                        key={talk.wordpress_id}
                    >
                        <LightYoutube
                            iframeText={talk.acf.youtube_iframe}
                            title={talk.title}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}
